export const APP_ROUTES = {
  LOGIN: 'login',
  DASHBOARD: '',
  OFERTAS: {
    BASE: 'ofertas',
    NUEVA: 'ofertas/nueva',
    DETALLE: (id: number | string) => `ofertas/${id}`,
    COMPARAR: (id: number | string) => `ofertas/${id}/comparar`,
  },
};
